/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Comfort_And_Night_Temperature_Per_RoomInputs */



/**
* | output |
* | --- |
* | "Comfort and night temperature per room" |
*
* @param {Comfort_And_Night_Temperature_Per_RoomInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const comfort_and_night_temperature_per_room = /** @type {((inputs?: Comfort_And_Night_Temperature_Per_RoomInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Comfort_And_Night_Temperature_Per_RoomInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Comfort and night temperature per room")
	return /** @type {LocalizedString} */ ("Température confort et nuit par pièce")
});